module.exports = __webpack_public_path__ + "static/media/12-10.d9718494.mp3";